import React from 'react';
import { LocationSearch } from '../../../components';

export default function PoisDestinationTab() {
  return <LocationSearch key="tab-pois-service" orderBy="tours-counter" onlyPreview={false}/>;
}
